import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Blog1 from "./components/Blog1/Blog1";
import Blog2 from "./components/Blog2/Blog2";
import AOS from "aos";
import "aos/dist/aos.css";
import Landing from "./components/Landing/Landing";
import ScrollToTopButton from "./components/ScrollToTopButton";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [pathname]);

  return null;
}

export default function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/blog1" element={<Blog1 />}></Route>
          <Route path="/blog2" element={<Blog2 />}></Route>
        </Routes>
        <ScrollToTopButton />
      </BrowserRouter>
    </HelmetProvider>
  );
}
